<template>
    <div
        class="card"
        v-if="mutableCourse"
        v-loading="loading"
        element-loading-text="Cargando..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
    >
        <div class="card-body">
            <form @submit.prevent="update">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Nombre del ISO</label>
                                    <input
                                        type="text"
                                        v-model="mutableCourse.name"
                                        class="form-control"
                                        placeholder="Titulo del curso"
                                    />
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label>Introducción</label>
                                    <textarea
                                        class="form-control"
                                        v-model="mutableCourse.intro"
                                        rows="5"
                                        style="resize: none"
                                        placeholder="Descripción del curso"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <label>Subir Portada</label>
                        <el-upload
                            class="picture-card"
                            ref="courseUpload"
                            action=""
                            drag
                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.webp"
                            :on-change="onUploadChange"
                            :http-request="update"
                            :multiple="false"
                            :limit="1"
                            :auto-upload="false"
                            :file-list="fileList"
                            :on-exceed="handleExceed"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                Suelta tu archivo aquí o
                                <em>haz clic para cargar</em>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                Solo archivos jpg/png con un tamaño menor de
                                100kb
                            </div>
                        </el-upload>
                    </div>

                    <div class="col-lg-6">
                        <label>Subir background de página</label>
                        <el-upload
                            class="picture-card"
                            ref="courseUpload2"
                            action=""
                            drag
                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.webp"
                            :on-change="onUploadChange2"
                            :http-request="update"
                            :multiple="false"
                            :limit="1"
                            :auto-upload="false"
                            :file-list="fileList2"
                            :on-exceed="handleExceed"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                Suelta tu archivo aquí o
                                <em>haz clic para cargar</em>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                Solo archivos jpg/png con un tamaño menor de
                                100kb
                            </div>
                        </el-upload>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Tiempo requerido</label>
                            <textarea
                                class="form-control"
                                v-model="mutableCourse.time_obtaining"
                                rows="5"
                                style="resize: none"
                                placeholder="Detalles acerca del curso"
                            ></textarea>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Tiempo de validez</label>
                            <textarea
                                class="form-control"
                                v-model="mutableCourse.time_validity"
                                rows="5"
                                style="resize: none"
                                placeholder="Lo que aprendera en el curso"
                            ></textarea>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Pasos para implementarlo</label>
                            <textarea
                                class="form-control"
                                v-model="mutableCourse.steps_implementation"
                                rows="5"
                                style="resize: none"
                                placeholder="Conocimientos previos para llevar el curso"
                            ></textarea>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Beneficios</label>
                            <textarea
                                class="form-control"
                                v-model="mutableCourse.benefits"
                                rows="5"
                                style="resize: none"
                                placeholder="A quienes va destinado el curso"
                            ></textarea>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center">
                    <el-button
                        :disabled="isSubmitting"
                        round
                        color="#ffc107"
                        dark
                        @click="update"
                        >Actualizar</el-button
                    >
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        course: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isSubmitting: false,
            loading: false,
            extensions: ".jpeg, .jpg, .png, .webp",
            mutableCourse: null,
            fileList: [],
            fileList2: [],
            url: "https://ipssoma-storage.s3.eu-west-1.amazonaws.com/",
        };
    },
    watch: {
        course: function (value) {
            this.mutableCourse = value;
            this.fillFiles();
        },
    },

    methods: {
        fillFiles() {
            this.fileList = [
                {
                    name: this.mutableCourse.cover_name,
                    url: `${this.url}${this.mutableCourse.url_image_cover}`,
                },
            ];

            this.fileList2 = [
                {
                    name: this.mutableCourse.page_name,
                    url: `${this.url}${this.mutableCourse.url_image_page}`,
                },
            ];
        },

        handleRemove(fileremoved, file) {
            this.fileList = file;
        },

        handleExceed(file) {
            if (this.fileList.length >= 1) {
                this.$message.error("Solo puede seleccionar 1 archivo!");
                return false;
            }

            const isLt1M = file.size < 500000;

            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 100kb!");
                return false;
            }
        },
        onUploadChange(file) {
            this.fileList = [];

            const isImage =
                file.raw.type === "image/jpeg" ||
                file.raw.type === "image/png" ||
                file.raw.type === "image/webp" ||
                file.raw.type === "image/jpg";

            const isLt1M = file.size < 800000;

            if (!isImage) {
                this.$message.error(
                    "Solo puede cargar archivos en formato jpg|jpeg|png."
                );
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 500kb!");
                this.$refs.courseUpload.clearFiles();
                return false;
            }

            this.fileList.push(file);
        },

        onUploadChange2(file) {
            this.fileList2 = [];

            const isImage =
                file.raw.type === "image/jpeg" ||
                file.raw.type === "image/png" ||
                file.raw.type === "image/webp" ||
                file.raw.type === "image/jpg";

            const isLt1M = file.size < 800000;

            if (!isImage) {
                this.$message.error(
                    "Solo puede cargar archivos en formato jpg|jpeg|png  y webp.."
                );
                this.$refs.courseUpload2.clearFiles();
                return false;
            }
            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 800kb!");
                this.$refs.courseUpload2.clearFiles();
                return false;
            }

            this.fileList2.push(file);
        },

        hasEspecialCharacters(text) {
            const regex = new RegExp(
                /^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g
            );
            return regex.test(text);
        },
        validateFields() {
            if (
                !this.mutableCourse.name ||
                this.mutableCourse.name.trim() === "" ||
                this.mutableCourse.name.length === 0
            ) {
                this.$message.warning("Titulo esta vacio!");
                return false;
            }

            if (this.mutableCourse.name.length > 50) {
                this.$message.warning("Titulo demasiado largo!");
                return false;
            }

            if (
                !this.mutableCourse.intro ||
                this.mutableCourse.intro.trim() === "" ||
                this.mutableCourse.intro.length === 0
            ) {
                this.$message.warning("Introducción esta vacio!");
                return false;
            }

            if (!this.$refs.courseUpload) {
                this.$message.warning("La portada del iso esta vacio!");
                return false;
            }

            if (!this.$refs.courseUpload2) {
                this.$message.warning("El background del iso esta vacio!");
                return false;
            }

            return true;
        },
        async update() {
            if (this.validateFields()) {
                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append("id", this.course.id);
                formdata.append("name", this.mutableCourse.name);
                formdata.append("intro", this.mutableCourse.intro);
                formdata.append(
                    "time_obtaining",
                    this.mutableCourse.time_obtaining
                );
                formdata.append(
                    "time_validity",
                    this.mutableCourse.time_validity
                );
                formdata.append(
                    "steps_implementation",
                    this.mutableCourse.steps_implementation
                );
                formdata.append("benefits", this.mutableCourse.benefits);

                if (this.fileList.length > 0) {
                    formdata.append("file", this.fileList[0].raw);
                }

                if (this.fileList2.length > 0) {
                    formdata.append("file2", this.fileList2[0].raw);
                }

                try {
                    this.loading = true;
                    const request = await axios({
                        url: `isos/update`,
                        method: "post",
                        data: formdata,
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                    const response =
                        request.status == 200
                            ? this.$message.success(
                                  "El curso ha sido actualizado correctamente"
                              )
                            : await this.$message.warning(
                                  "Error al validar datos"
                              );
                    this.isSubmitting = false;
                    this.loading = false;
                    this.fileList = [];
                    $("#edit-course-modal").modal("hide");
                    location.reload();
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    $("#edit-course-modal").modal("hide");
                    console.log(error);
                }
            }
        },
    },
};
</script>
